export default {
  APP_NAME: "Paranoid Android",
  APP_SUBNAME: "Paranoid Android",
  APP_DESC: "Paranoid Android",
  APP_LOGO: "/img/logo.png",
};
